import { JwtPayload as BaseJwtPayload, jwtDecode } from 'jwt-decode';
import progressMagicJwtToken, { authTokenSilentRefreshCycleTime } from '../config/constants';

interface JwtPayload extends BaseJwtPayload {
  'cognito:groups': string[];
}

export const parseJwt = (token: string) => JSON.parse(atob(token.split('.')[1]));

export const isTokenAboutToExpire = (token: string) => {
  const decoded = parseJwt(token);
  const nextRefreshCycle = new Date().getTime() + authTokenSilentRefreshCycleTime;

  return decoded.exp * 1000 < nextRefreshCycle;
};

export const isTokenExists = () => {
  const token = localStorage.getItem(progressMagicJwtToken);
  return !!token;
};

export const isTokenValid = () => {
  const token = localStorage.getItem(progressMagicJwtToken);
  if (token) {
    const decodedToken = parseJwt(token);
    return decodedToken.exp * 1000 > new Date().getTime();
  }
  return false;
};

export const getUserGroups = () => {
  const token = localStorage.getItem(progressMagicJwtToken);
  if (token) {
    const decodedToken: JwtPayload = jwtDecode(token as string);
    return decodedToken['cognito:groups'] as string[];
  }
  return null;
};

export const decodedData = (
  token: string
): {
  email: string;
  firstName: string;
  principalCoach: string;
} => {
  const decodedToken: {
    email: string;
    firstName: string;
    principalCoach: string;
  } = jwtDecode(token);
  return decodedToken;
};
